/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Box, IconButton, Tooltip, styled, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { userLogged } from '@selectors/user';
import { parseMessage } from '@src/locales/intl';
import {
  urlAnalyticsCustomerSatisfactionBinary,
  urlAnalyticsCustomerSatisfactionStars,
  urlAnalyticsFaqs,
  urlDepartments,
  urlFaqsQA,
  urlFaqsSetup,
  urlSatisfactionConfiguration,
} from '@src/utils/adminRoutes';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import BotButtons from './BotButtons';

const pathsAllowedForBotButtons = [
  urlFaqsSetup,
  urlFaqsQA,
  urlAnalyticsFaqs,
  urlSatisfactionConfiguration,
  urlAnalyticsCustomerSatisfactionBinary,
  urlAnalyticsCustomerSatisfactionStars,
  urlDepartments,
];
const useStyles = makeStyles(theme => ({
  root: {
    fontSize: '14px',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    color: theme.palette.text.secondary,
  },
}));

export const LayoutStyled = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  margin: 'auto',
  height: '100%',
  minHeight: '100%',
  overflow: 'hidden',
}));

const BotButtonsWrapper: React.FC = () => {
  const { pathname } = useLocation();
  const { admin } = useSelector(userLogged);

  const lblBtnChannels = parseMessage('Bot.Channels.Title');
  const lblBotButtonsInfo = parseMessage('Bot.Buttons.Info');

  const customStyle = useStyles();
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';
  const ddlRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  if (!pathsAllowedForBotButtons.includes(pathname) || !admin) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        height: 40,
        borderRadius: 100,
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.15)' : '#DBDDE1'}`,
      }}
      style={{ backgroundColor: theme.palette.background.paper }}
    >
      <Box display="flex" sx={{ padding: '10px 0' }}>
        <Tooltip title={lblBotButtonsInfo}>
          <InfoOutlinedIcon />
        </Tooltip>
      </Box>
      <IconButton
        classes={{ root: customStyle.root }}
        disableRipple
        aria-label="bot-buttons-select"
        ref={ddlRef}
        onClick={() => {
          setAnchorEl(ddlRef.current);
        }}
      >
        {lblBtnChannels}{' '}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="4"
          viewBox="0 0 6 4"
          fill="none"
          style={{ marginLeft: 16 }}
        >
          <g clipPath="url(#clip0_111_39)">
            <path
              d="M0.247736 1.43121L2.41194 3.59894C2.73782 3.92535 3.26425 3.92535 3.59013 3.59894L5.75432 1.43121C6.28075 0.90392 5.90473 0 5.16105 0H0.832655C0.0889723 0 -0.278691 0.90392 0.247736 1.43121Z"
              fill={theme.palette.text.secondary as string}
            />
          </g>
          <defs>
            <clipPath id="clip0_111_39">
              <rect width="6" height="3.84375" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </IconButton>

      <BotButtons
        anchorEl={anchorEl}
        handleClose={() => {
          setAnchorEl(null);
        }}
      />
    </Box>
  );
};

export default BotButtonsWrapper;
